import { FooterBranch } from '@/redux/services/footerApi'
import Link from 'next/link'

interface IProps {
    branches: FooterBranch[]
    selectedChapters: number | null
    onDropdownToggle: (id: number) => () => void
}

const FooterProduction: React.FC<IProps> = ({ selectedChapters, branches = [], onDropdownToggle }) => {
    return (
        <ul className='footer__production-list product__info'>
            {branches?.map((branch, i) => {
                // const isSelected = selectedChapters.includes(branch.id)
                const isSelected = selectedChapters === branch.id

                return (
                    <li
                    key={i}
                        onClick={onDropdownToggle(branch.id)}
                        className={`footer__production ${isSelected ? 'product__chapter_open' : 'product__chapter'}`}
                    >
                        <div
                            onClick={onDropdownToggle(branch.id)}
                            className='product__chapter-head'
                        >
                            {isSelected ? (
                                <div className='footer__production-tag'>
                                    <p className='categories-slider__text'>{branch.desc}</p>
                                </div>
                            ) : (
                                <h3 className='footer__production-title product__chapter-title'>{branch.city}</h3>
                            )}
                            <div className='product__chapter-state'>
                                <span
                                    className={
                                        isSelected
                                            ? 'product__chapter-state-line product__chapter-state-line_minus'
                                            : 'product__chapter-state-line'
                                    }
                                ></span>
                                <span
                                    className={
                                        isSelected
                                            ? 'product__chapter-state-line product__chapter-state-line_minus'
                                            : 'product__chapter-state-line'
                                    }
                                ></span>
                            </div>
                        </div>
                        <div
                            className={`footer__production-chapter ${isSelected ? 'product__chapter_open' : 'product__chapter'
                                }`}
                        >
                            <h3 className='footer__production-subtitle'>{branch.title}</h3>
                            <p className='footer__production-address'>{branch.address}</p>
                            <div className='footer__production-contacts'>
                                <Link
                                    href={''}
                                    className='footer__production-number'
                                >
                                    {branch.phone}
                                </Link>
                                <Link
                                    href={''}
                                    className='footer__production-mail'
                                >
                                    {branch.email}
                                </Link>
                                <Link
                                    href={branch.link}
                                    className='footer__production-link'
                                >
                                    Яндекс.Карты
                                    <svg
                                        width='8'
                                        height='8'
                                        viewBox='0 0 8 8'
                                        fill='none'
                                        xmlns='http://www.w3.org/2000/svg'
                                    >
                                        <path
                                            d='M7.25685 0.999396C7.25685 0.668025 6.98823 0.399396 6.65685 0.399396L1.25685 0.399396C0.925483 0.399396 0.656854 0.668025 0.656854 0.999396C0.656854 1.33077 0.925483 1.5994 1.25685 1.5994L6.05685 1.5994L6.05685 6.3994C6.05685 6.73077 6.32548 6.9994 6.65685 6.9994C6.98823 6.9994 7.25685 6.73077 7.25685 6.3994L7.25685 0.999396ZM0.575736 6.23199C0.341421 6.4663 0.341421 6.8462 0.575736 7.08051C0.810051 7.31483 1.18995 7.31483 1.42426 7.08051L0.575736 6.23199ZM1.42426 7.08051L7.08112 1.42366L6.23259 0.575132L0.575736 6.23199L1.42426 7.08051Z'
                                            fill='#FEAA9F'
                                        />
                                    </svg>
                                </Link>
                            </div>
                        </div>
                    </li>
                )
            })}
        </ul>
    )
}

export default FooterProduction
